import React from 'react';
import './Result.css';

function Result({tests}) {
  
  return (
    <div>
        {tests.result === true? 
        <p className='result__solved'>Поздравляем, задача решена</p>
        : <p className='result__not-solved'>Задача не решена, попробуйте еще раз</p>
        }
    </div>
  );
}

export default Result;
